export const languagesAndFrameworks = [
    'Java', 
    'Javascript',
    'Dart',
    'React', 
    'Flutter', 
    'Apache Kafka', 
    'AG-Grid / HighCharts', 
    'Apache Spark', 
    'GraphQL',
];
export const favouriteReads = [
    'When Breath Becomes Air', 
    'Man\'s Search for Meaning', 
    'And then there were None',
    'The Maltese Falcon',
    'Crime and Punishment',
];
export const volunteeringText = [
    'Writing Club - Wrote articles, stories, poems, and social media content for the annual cultural festival of the college',
    'Social Responsibility Club - Volunteered at a competition conducted at a primary school and a day-long event held at a center for blind women'
];

export const WHEN_BREATH_BECOMES_AIR = "when-breath-becomes-air";

export const bookReviewTitlesMap = {
    'when-breath-becomes-air': 'When Breath Becomes Air',
};


export const WhenBreathBecomesAir = () => {
    return (
        <div>
            Autobiographies are never my first choice of genre. I made an exception with this one. I can count on one hand the number
            of autobiographies I've read in my life. <br /><br />
            <span className="hover:border-b-4 hover:border-b-black"><i><a href="https://www.goodreads.com/book/show/43015.A_Long_Way_Gone"> I am Malala</a></i></span> and 
            <span className="hover:border-b-4 hover:border-b-black"><i><a href="https://www.goodreads.com/book/show/17851885-i-am-malala"> A long way gone</a></i></span> are a two good reads that I am able 
            to recall as of writing this.
            Having said that, I place this book as one of the most impactful books that 
            I have ever read in my life. It was the first time I bawled my eyes out as I reached the ending. <br /><br />
            Coming to the book itself, it's about a highly accomplished neurosurgeon with all the right qualifications and all 
            the right accolades for whom the end is nigh. The autobiography is the one last thing the author makes an attempt to 
            complete before <i>his breath becomes air</i> (couldn't resist +_+). As to the writing itself, it starts of with a lot of 
            dreamy writing, with big picture perspectives on life, which would make sense if you find yourself standing on a ledge with nothingness in front 
            of you. <br /><br />
            I sort of got the impression that it was similar to but completely polar opposite in sentiment to Dostoyevky's writing. Anyway,
            that was the first part of the book. In the middle portion, there is a lot of medical jargon thrown around. There's also no 
            attempt made to hide how gruelling a career in medicine is. There's also the distinct inkling that the writer was not shying
            away from putting himself on a higher pedestal because of the nobility and impact his profession has. But, then again, it tallies
            well with such professions having a significant portion of its professionals with large egos and complexes. In no way I mean to attack
            the profession, but rather I am stating it matter-of-factly that it is a consequence of the profession and more specifically the 
            speciality itself. But I digress.
            <br /><br />
            Going back on track, the last section of the book is what made me categorise this as impactful. The writer never ends up completing
            his story. But in my opinion, his autobiography not having an ending was the perfect ending the book could ever have given the state 
            in which he commenced writing it. There is a closure penned by his wife, where she goes in some detail to explain this sentiment but
            in a much better manner. If reading this section does not trigger a "dust allergy", I don't know what can. 
            <br /><br />
            If you reached till here, you're probably thinking <i>"Oh look, a book made him cry and he qualifies it as life-changing?"</i>
            <br /><br />
            You'd probably be partially right. I didn't start uprooting and altering parts of my life but I started thinking about them. I also 
            use it as a vantage point to make changes to some of the beliefs and perspectives I hold.
        </div>
    );
}

export const bookReviewDescriptionMap = {
    'when-breath-becomes-air': <WhenBreathBecomesAir />
}